import { Layout } from '../../../common/components';
import GenerateReport from '../../sharedComponents/generateReport/generateReport';
import CommonFiltersHeader from '../../statements/commonFiltersHeader';

const Journals = () => {
  return (
    <Layout>
      <div className="j-layout">
        <CommonFiltersHeader page="journals" />
        <h3 className="jl-heading">Journals</h3>
        <GenerateReport page="journals" />
      </div>
    </Layout>
  );
};

export default Journals;
